module.exports = __webpack_public_path__ + "img/mascot-no-permission.007cf155.svg";